module.exports = __webpack_public_path__ + "static/img/29.ad58287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/29.png
// module id = 3D0+
// module chunks = 0